exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AuthSignupScreen .Form {\n  margin-bottom: 24px; }\n", ""]);

// exports
